/**
 * Persistence for the multisite report's selected venue set. React owns this
 * state and stores it under the `@@loaded/` namespace it uses for its own keys
 * (matching `@@loaded/debugEnabled` etc.). The AngularJS `multisite` service
 * reads the same key back via raw `localStorage` to decide which venues a report
 * covers (see `app/services/multisite/multisite.factory.js`); the value is no
 * longer round-tripped back to React through the AngularJS app context.
 */
const MULTISITE_SELECTED_KEY = '@@loaded/multisiteSelectedCompanies'

/**
 * Reads the persisted selected venue ids, or `null` when nothing is stored.
 * A `null` return is the caller's cue to materialise the all-selected default
 * (every accessible venue), matching the AngularJS behaviour this replaced.
 */
export function readMultisiteSelectedCompanies(): string[] | null {
  const raw = localStorage.getItem(MULTISITE_SELECTED_KEY)
  if (!raw) {
    return null
  }
  try {
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? (parsed as string[]) : null
  } catch {
    return null
  }
}

/**
 * Persists the selected venue ids so a refresh resolves the same selection.
 * Stored as a JSON array; the AngularJS `multisite` service reads it back via
 * raw `localStorage`.
 */
export function writeMultisiteSelectedCompanies(selectedIds: string[]): void {
  localStorage.setItem(MULTISITE_SELECTED_KEY, JSON.stringify(selectedIds))
}
